/** Gifting category tabs — maps UI ids to store menu slugs. */
export const GIFTING_CATEGORY_CONFIG = [
  {
    id: 'packs',
    label: 'Packs',
    menuSlugs: ['boxes', 'packs'],
  },
  {
    id: 'cakes',
    label: 'Cakes',
    menuSlugs: ['cakes', 'cookie-cakes'],
  },
  {
    id: 'ice-cream',
    label: 'Ice Cream',
    menuSlugs: ['ice-cream-2', 'ice-cream'],
  },
];

/** Shipping promo banner copy (GiftingCategoryShippingBannerBrandRefresh). */
export const GIFTING_SHIPPING_BANNER_COPY = {
  title: 'Signed, sealed, and still warm.',
  body:
    'Every gift ships sealed with our To/From sticker, so it arrives looking like a present, not a delivery.',
};
